import React from "react";
import { scrollToId } from "../lib/site";

export const Logo = ({ compact = false }) => (
  <button
    type="button"
    onClick={() => scrollToId("inicio")}
    data-testid="logo-button"
    aria-label="EDALIX Tecnologia — voltar ao início"
    className="group flex items-center gap-3"
  >
    <span className="relative block h-9 w-9 rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#8A2BE2] p-[1.5px] transition-transform duration-300 group-hover:scale-105">
      <span className="flex h-full w-full items-center justify-center rounded-[7px] bg-[#050508]">
        <span className="text-gradient font-display text-lg font-black">E</span>
      </span>
    </span>
    {!compact && (
      <span className="text-left leading-none">
        <span className="block font-display text-base font-bold tracking-[0.18em] text-white">
          EDALIX
        </span>
        <span className="mt-1 block text-[9px] font-medium tracking-[0.42em] text-white/50">
          TECNOLOGIA
        </span>
      </span>
    )}
  </button>
);

export default Logo;
